import { Link, Stack, Text } from '@hotjar/hotsauce';
import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import ThankYouIllustration from '../../../assets/images/person_celebrating.svg';
import { useThankYouDetails } from '../../api';
import { WithErrorBoundary } from '../../components/ErrorBoundary/ErrorBoundary';
import { FullScreen } from '../../components/FullScreen/FullScreen';
import { ListItem } from '../../components/ListItem/ListItem';
import { celebrate } from '../../utils/confetti';
import { getCurrency } from '../../utils/currency';
import useIsTabActive from '../../utils/hooks/useIsTabActive';
import { ImageContainer, ThankYouDetails, StyledText } from './ThankYouScreen.styles';
import { useProjectParams } from '../../utils/hooks/useProjectParams';

export function ThankYouScreenComponent() {
  const { t } = useTranslation('user-test', { keyPrefix: 'thank-you' });
  const [wasConfettiShown, setWasConfettiShown] = useState(false);
  const isTabVisible = useIsTabActive();
  const { getParam } = useProjectParams();
  const shareId = getParam('share_id');

  const { data } = useThankYouDetails({ shareId, auth: getParam('auth') });

  useEffect(() => {
    if (isTabVisible && !wasConfettiShown) {
      celebrate();
      setWasConfettiShown(true);
    }
  }, [isTabVisible, wasConfettiShown]);

  return (
    <FullScreen
      leftSide={
        <ThankYouDetails direction="column" spacing="x6">
          <Stack direction="column">
            <Text textType="header3" as="h3">
              {data?.thank_you.title || t('title')}
            </Text>
            <StyledText textType="body1">{data?.thank_you.message || t('description')}</StyledText>
          </Stack>
          <Stack direction="column" spacing="x3">
            <Text textType="header5" as="h5">
              {t('next.title')}
            </Text>
            <Stack direction="column" spacing="x1">
              {data?.compensation && (
                <ListItem
                  textType="body1"
                  icon="gift"
                  title={t('next.compensation', {
                    compensation: data?.compensation,
                    currency_symbol: getCurrency(data?.compensation_currency),
                  })}
                />
              )}
              {!data?.compensation_paid_by_system && data?.organization_name ? (
                <>
                  <ListItem
                    textType="body1"
                    icon="building_business"
                    title={t('next.company-compensation', { company: data.organization_name })}
                  />
                  <ListItem
                    textType="body1"
                    icon="help"
                    title={
                      <Trans
                        t={t}
                        i18nKey="next.other-queries"
                        components={{
                          contactLink: (
                            <Link href="mailto:contact@hotjar.com" kind="inline">
                              here
                            </Link>
                          ),
                        }}
                      />
                    }
                  />
                </>
              ) : (
                <ListItem textType="body1" icon="help" title={t('next.questions')} />
              )}
            </Stack>
          </Stack>
        </ThankYouDetails>
      }
      hideOnSmallScreen="right"
      rightSide={
        <ImageContainer>
          <img src={ThankYouIllustration} alt="thank you" />
        </ImageContainer>
      }
    />
  );
}

export const ThankYouScreen = WithErrorBoundary(ThankYouScreenComponent, 'ThankYouScreen');
